module.exports = __webpack_public_path__ + "img/upload_white.714d1622.svg";